import { CMSBlock } from "@jwm/types/CMSBlock";
import isEmpty from "lodash/isEmpty";
import isObject from "lodash/isObject";
import pickBy from "lodash/pickBy";

// GraphQL schema for modular blocks contains a property for each potential block type, but only 1 is non null at a time. Pick that one...
const getBlockType = (block: CMSBlock): string | undefined => {
    const actualBlock = pickBy(block, isObject);
    if (isEmpty(actualBlock)) {
        return "No Block Defined";
    } else {
        return Object.keys(actualBlock)[0];
    }
};

export default getBlockType;
